window.SiteReady(($) => {

  console.log('Init Block: Results Grid');

  function showItem($item) {
    $item.removeClass('screenreader');
  }

  function hideItem($item) {
    $item.addClass('screenreader');
  }

  function showItems($items, filterCategory = 'all') {
    if (filterCategory == 'all') {
      $items.each((_, item) => {
        showItem($(item));
      });
    } else {
      // -- Compare filter category to categories assigned to each item. Show item if there is a match.
      $items.each((_, item) => {
        const $item = $(item);
        const itemCategories = $item.data('categories');

        if (itemCategories.includes(filterCategory)) { // cats should have "|" delimiters for this to work correctly
          showItem($item);
        } else {
          hideItem($item);
        }
      });
    }
  }

  function hideViewAllButton($button) {
    $button.parent().addClass('hidden');
  }

  // Lifts style.less's six-result limit; filtering takes over from there
  function expandGrid($grid) {
    $grid.addClass('results_grid_expanded');
  }

  $('.block_results_grid.js-results_grid').each((_, grid) => {
    const $grid = $(grid);
    const $filters = $grid.find('.js-result_filter_item');
    const $items = $grid.find('.js-result_item');
    const $viewAllButton = $grid.find('.js-results_grid_button');

    $filters.each((_, filter) => {
      const $filter = $(filter);

      // --- Handle click on filter button
      $filter.on('click', (e) => {
        const $currentFilter = $(e.currentTarget);
        const filterCategory = $currentFilter.data('category');

        $filters.removeClass('active');
        $currentFilter.addClass('active');

        expandGrid($grid);
        showItems($items, filterCategory);
        hideViewAllButton($viewAllButton);

        if (typeof window.refreshPills === 'function') {
          window.refreshPills();
        }
      });
    });

    // --- Handle click on view all button
    $viewAllButton.on('click', () => {
      expandGrid($grid);
      hideViewAllButton($viewAllButton);
    });
  });
});
